
import { createPool, format, Pool, PoolConnection } from "mysql2/promise";
import { StandardError, TransactionError } from "@errors";
import { BaseConnection } from "./_base.connection";

export class MysqlTypeConnection extends BaseConnection {
	pool: Pool;
	protected transactionActive = false;
	protected transactionConnection: PoolConnection | null = null;

	constructor(host: string, port: number, user: string, password: string, database: string, connectionLimit = 5, queueLimit = 0) {
		super();
		this.pool = createPool({
			host,
			user,
			port,
			password,
			database,
			waitForConnections: true,
			connectionLimit,
			queueLimit,
			debug: process.env.NODE_ENV == "debug"
		});
		return this;
	}

	public logQuery(queryString: string, queryData: any) {
		console.log(this.formatQuery(queryString, queryData));
	}

	public formatQuery(queryString: string, queryData: any) {
		return format(queryString, queryData);
	}

	public async exec(queryString: string, queryData: any, options: { [key: string]: any }): Promise<any> {
		if (process.env.NODE_ENV !== "production")
			this.logQuery(queryString, queryData);
		try {
			let results;
			if (this.transactionActive && this.transactionConnection)
				[results] = await this.transactionConnection.query({ sql: queryString, values: queryData, ...options });
			else
				[results] = await this.pool.query({ sql: queryString, values: queryData, ...options });
			return results;
		} catch (error) {
			throw new TransactionError(error);
		}
	}

	public async beginTransaction() {
		try {
			this.transactionConnection = await this.pool.getConnection();
			this.transactionActive = true;
			await this.transactionConnection.beginTransaction();
		} catch (error) {
			throw new StandardError(error, "Error beginning transaction");
		}
	}

	public async commitTransaction() {
		try {
			this.transactionActive = false;
			await this.transactionConnection?.commit();
			this.transactionConnection?.release();
		} catch (error) {
			throw new StandardError(error, "Error committing transaction");
		}
	}

	public async rollbackTransaction() {
		try {
			this.transactionActive = false;
			await this.transactionConnection?.rollback();
			this.transactionConnection?.release();
		} catch (error) {
			throw new StandardError(error, "Error committing transaction");
		}
	}
}